import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Select, Descriptions, Spin, Button, Card } from 'antd'
import BunkeyAPI from '../../api/BunkeyAPI'
import GraphicLine from '../graphics/GraphicLine'
import './Reports.css'

const { Option } = Select
const DAYS_7 = 7
const DAYS_30 = 30
const DAYS_90 = 90
const DAYS_180 = 180
const DAYS_365 = 365

export class Reports extends Component {

  constructor(props) {
    super(props)

    this.state = {
      isFetching: true,
      days: DAYS_7,
      data: []
    }
  }

  componentDidMount() {
    this.handleGetData()
  }

  handleGetData = () => {
    BunkeyAPI({
      url: `/clients/getTypeRecentReport?type=Base`,
      method: 'GET',
    }).then(resp => {
      if (resp && resp.status === 200) {
        this.setState({
          isFetching: false,
          data: resp.data.output
        })
      }
    }).catch(err => {

    })
  }

  handleAddDetail = row => {
    const { data } = this.state

    this.setState({
      data: data.map(r => r.idClient === row.idClient
        ? {
          ...r,
          isFetching: true
        }
        : { ...r })
    }, () => {
      BunkeyAPI({
        url: `/clients/getSpaceFolder`,
        method: 'POST',
        data: {
          client: row.idClient
        }
      }).then(resp => {
        if (resp && resp.status === 200) {
          this.setState({
            data: data.map(r => r.idClient === row.idClient
              ? {
                ...r,
                isFetching: false,
                s3: resp.data.size
              }
              : { ...r })
          })
        }
      }).catch(err => {
        console.log('ERR: ', err)
      })
    })
  }

  handleRemoveDetail = row => {
    const { data } = this.state
    this.setState({
      data: data.map(r => r.idClient === row.idClient
        ? {
          ...r,
          s3: null
        }
        : { ...r })
    })
  }

  hanleOnChange = value => {
    this.setState({
      days: value
    })
  }

  render() {
    const { isFetching, data, days } = this.state
    const { newColor, intl } = this.props

    return (<React.Fragment>
      <div className="title-bar">
        <div className="container" style={{ borderLeftColor: newColor }} >
          <span>{intl.formatMessage({ id: "report" })}</span>
          <div style={{
            display: 'block',
            float: 'right',
            marginRight: 15,
            marginTop: 10
          }}>
          </div>
        </div>
      </div>
      <div className="assets-wrapper">
        <div className="container">
          {isFetching && <div className="div-loading">
            <Spin />
          </div>}
          {!isFetching && <React.Fragment>
            <table style={{ width: '100%', textAlign: 'center', border: '1px solid #e8e8e8', marginTop: '18px' }} className="ant-table ant-table-default ant-table-bordered  ant-table-scroll-position-left" >
              <thead className="ant-table-thead">
                <tr>
                  <th style={{ width: '35%', textAlign: 'center' }}>
                    <span className="ant-table-header-column">
                      <div>
                        <span className="ant-table-column-title">{intl.formatMessage({ id: "clients_client" })}</span>
                      </div>
                    </span>
                  </th>
                  <th style={{ width: '65%', textAlign: 'center' }}>
                    <span className="ant-table-header-column">
                      <div>
                        <span className="ant-table-column-title">{intl.formatMessage({ id: "report_info_and_details" })}</span>
                      </div>
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody >
                {data.map(r => {
                  return <React.Fragment key={r.idClient}>
                    <tr >
                      <td className='td'><span >{r.nameClient}</span></td>
                      <td className='td' >
                        <span >
                          {r.s3 && r.s3 !== '' && <Button style={{ backgroundColor: newColor, border: 'none', float: 'right' }} size={'small'} type="primary" onClick={() => this.handleRemoveDetail(r)} >&times;</Button>}
                          {!r.s3 && <Button type="primary" style={{ backgroundColor: newColor, border: 'none' }} size={'small'} loading={r.isFetching} onClick={() => this.handleAddDetail(r)} >{intl.formatMessage({ id: "details" })} </Button>}
                        </span>
                      </td>
                    </tr>
                    {r.s3 && r.s3 !== '' && <tr key={`${r.idClient}_detail`}>
                      <td style={{ padding: '7px' }} >
                        <Descriptions
                          bordered
                          column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                        >
                          <Descriptions.Item label="Tipo de asset">Cantidad</Descriptions.Item>
                          <Descriptions.Item label="Imágenes">{new Intl.NumberFormat("de-DE").format(r.detail.images)}</Descriptions.Item>
                          <Descriptions.Item label="Carpetas">{new Intl.NumberFormat("de-DE").format(r.detail.folders)}</Descriptions.Item>
                          <Descriptions.Item label="Documentos">{new Intl.NumberFormat("de-DE").format(r.detail.documents)}</Descriptions.Item>
                          <Descriptions.Item label="Videos">{new Intl.NumberFormat("de-DE").format(r.detail.videos)}</Descriptions.Item>
                          <Descriptions.Item label="Total assets">{new Intl.NumberFormat("de-DE").format(r.detail.images + r.detail.documents + r.detail.videos)}</Descriptions.Item>
                          <Descriptions.Item label="Total de usuarios">{new Intl.NumberFormat("de-DE").format(r.totalUsers)}</Descriptions.Item>
                          <Descriptions.Item label="Peso total almacenado">{r.s3}</Descriptions.Item>
                        </Descriptions>
                      </td>
                      <td >
                        <Card style={{ textAlign: 'center', margin: 0, padding: '0 !important' }} >
                          <Select defaultValue={days} onChange={this.hanleOnChange} style={{ width: 120 }}>
                            <Option value={DAYS_7}>7 {intl.formatMessage({ id: "days" })}</Option>
                            <Option value={DAYS_30}>30 {intl.formatMessage({ id: "days" })}</Option>
                            <Option value={DAYS_90}>90 {intl.formatMessage({ id: "days" })}</Option>
                            <Option value={DAYS_180}>180 {intl.formatMessage({ id: "days" })}</Option>
                            <Option value={DAYS_365}>365 {intl.formatMessage({ id: "days" })}</Option>
                          </Select>
                          <GraphicLine data={r.totalAccess.slice(r.totalAccess.length - days, r.totalAccess.length).map(r => {
                            return {
                              "x": r.date,
                              "accesos": r.qty
                            }
                          })} />
                        </Card>
                      </td>
                    </tr>}
                  </React.Fragment>
                })}
              </tbody>
            </table>
          </React.Fragment>}
        </div>
      </div >
    </React.Fragment >)
  }
}

const mapStateToProps = state => {
  return {
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
  }

}

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Reports)))
